import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { withDataConverter } from '@beef/react';
import React from 'react';
import { getWindow } from "../../../../../../../../utils/window";
import { ymPushParams } from "../../../../../../../../utils/ym.alternative";
import { getAccountType } from "../../../../../../../../utils/analytics";
import { getContent } from "../../../../../../../dependencies/getContent/dev";
import { getIsLoggedIn } from "../../../../../../../dependencies/getIsLoggedIn/dev";
import { Option } from "../Option";
import { getAnalyticsConverter } from "./analytics";
import { getMapStateToPaymentOptionsProps } from "./logic/logic";
import { getIconProps } from "../Option/utils";
var analyticsConverter = getAnalyticsConverter({
  getAccountType: getAccountType,
  getWindow: getWindow,
  ymPushParams: ymPushParams
});
// @ts-expect-error withDataConverter without .d.ts
export var PaymentOption = withDataConverter(analyticsConverter)(function (props) {
  return /*#__PURE__*/React.createElement(Option, _extends({}, props, {
    rightComponentProps: _objectSpread(_objectSpread({}, props.rightComponentProps), {}, {
      color: 'tertiary'
    }),
    "data-t-id": "PaymentMethodSection-PaymentOption"
  }));
});

/**
 * Set up dependencies for the payment options section state mapping.
 *
 * NOTE: Index files are responsible for connecting dependencies to their respective logic
 * This approach uses a hierarchical composition pattern, where dependencies are organized
 * at the same level as their corresponding components. This keeps the codebase modular
 * and easier to maintain.
 * The top-level index.ts file gathers dependencies from the index.ts files of other components
 * and composes them following the same hierarchy as the components.
 * */
export var mapStateToPaymentOptionsProps = getMapStateToPaymentOptionsProps({
  getContent: getContent,
  getIsLoggedIn: getIsLoggedIn,
  Component: PaymentOption,
  getIconProps: getIconProps
});